module.exports = __webpack_public_path__ + "img/camp_shirt_gk11.9550ed68.svg";